module.exports = __webpack_public_path__ + "media/pro/VC-813d5a4f.png";